var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "OUTLINE_copy_2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_8180",
    "data-name": "Path 8180",
    d: "M10.034,17.621h1.03v5.2h1v-5.2h1.03v-.884H10.034Z",
    fill: "#faf7f5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_8181",
    "data-name": "Path 8181",
    d: "M15.117,21.745a1.213,1.213,0,0,1-.275.24.489.489,0,0,1-.247.095.224.224,0,0,1-.182-.071.387.387,0,0,1-.054-.231V18.332h-.883v3.756a.981.981,0,0,0,.155.6.546.546,0,0,0,.462.2,1.08,1.08,0,0,0,.514-.143,1.9,1.9,0,0,0,.51-.416v.493H16V18.33h-.883v3.415Z",
    fill: "#faf7f5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_8182",
    "data-name": "Path 8182",
    d: "M18.344,18.278a.858.858,0,0,0-.408.107,1.348,1.348,0,0,0-.379.313V16.737h-.893v6.09h.893v-.345a1.137,1.137,0,0,0,.377.3,1.035,1.035,0,0,0,.462.1.724.724,0,0,0,.6-.253A1.133,1.133,0,0,0,19.2,21.9V19.406a1.344,1.344,0,0,0-.222-.84.75.75,0,0,0-.638-.288ZM18.3,21.773a.487.487,0,0,1-.078.309.285.285,0,0,1-.238.095.478.478,0,0,1-.213-.049.78.78,0,0,1-.21-.158v-2.8a.658.658,0,0,1,.182-.137.419.419,0,0,1,.187-.043.34.34,0,0,1,.276.117.541.541,0,0,1,.094.345Z",
    fill: "#faf7f5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_8183",
    "data-name": "Path 8183",
    d: "M15.872,12.159a.453.453,0,0,0,.321-.112.418.418,0,0,0,.119-.313v-2.7a.323.323,0,0,0-.122-.263.488.488,0,0,0-.318-.1.427.427,0,0,0-.3.1.338.338,0,0,0-.114.263v2.7a.446.446,0,0,0,.107.315.393.393,0,0,0,.3.112Z",
    fill: "#faf7f5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_8184",
    "data-name": "Path 8184",
    d: "M16,0A16,16,0,1,0,32,16,16,16,0,0,0,16,0Zm2.132,7.942h.993v3.794a.413.413,0,0,0,.064.254.239.239,0,0,0,.2.079.573.573,0,0,0,.277-.1,1.3,1.3,0,0,0,.306-.267V7.942h1v4.949h-1v-.546a2.079,2.079,0,0,1-.572.46,1.23,1.23,0,0,1-.578.158.623.623,0,0,1-.52-.221,1.06,1.06,0,0,1-.174-.664V7.942ZM14.438,9.074a1.135,1.135,0,0,1,.4-.916,1.613,1.613,0,0,1,1.079-.341,1.444,1.444,0,0,1,1.012.36,1.2,1.2,0,0,1,.394.925v2.557a1.3,1.3,0,0,1-.386,1,1.5,1.5,0,0,1-1.066.361,1.459,1.459,0,0,1-1.045-.372,1.326,1.326,0,0,1-.39-1V9.074ZM11.729,6.182l.727,2.681h.07l.691-2.681h1.139l-1.3,3.925v2.784h-1.12V10.233L10.6,6.183s1.129,0,1.129,0ZM22.836,24.17c-.726.724-6.839.74-6.839.74s-6.114-.015-6.841-.74-.729-4.3-.729-4.33,0-3.6.729-4.33S16,14.776,16,14.777s6.114.009,6.839.734.737,4.309.737,4.33C23.573,19.84,23.567,23.441,22.836,24.17Z",
    fill: "#faf7f5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_8185",
    "data-name": "Path 8185",
    d: "M21.011,18.222a1.316,1.316,0,0,0-.967.368,1.278,1.278,0,0,0-.375.953V21.56a1.454,1.454,0,0,0,.342,1.02,1.2,1.2,0,0,0,.934.37,1.308,1.308,0,0,0,.991-.347,1.459,1.459,0,0,0,.332-1.043v-.23H21.36v.2a.967.967,0,0,1-.089.513.358.358,0,0,1-.307.116.328.328,0,0,1-.3-.136,1,1,0,0,1-.087-.493V20.69h1.689V19.544a1.368,1.368,0,0,0-.324-.98,1.221,1.221,0,0,0-.931-.342Zm.349,1.766h-.781v-.453a.675.675,0,0,1,.091-.4.351.351,0,0,1,.3-.123.334.334,0,0,1,.293.123.658.658,0,0,1,.094.4v.453Z",
    fill: "#faf7f5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.11738809f82a53122c86d75274466139.svg";
export { ForwardRef as ReactComponent };